import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ResetSurveySettingsRPC } from "./resetSurveySettingsRPC";

export class ResetSurveySettingsRPCClientImpl extends ResetSurveySettingsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ResetSurveySettingsRPC.Request): Promise<LeoRPCResult<ResetSurveySettingsRPC.Response, ResetSurveySettingsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ResetSurveySettings",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ResetSurveySettingsRPC.ResponseDTO,
      ResetSurveySettingsRPC.Errors.ErrorsDTO,
      ResetSurveySettingsRPC.Response,
      ResetSurveySettingsRPC.Errors.Errors
    >(
      response,
      "survey/ResetSurveySettings",
      ResetSurveySettingsRPC.Response.fromDTO,
      ResetSurveySettingsRPC.Errors.fromDTO
    );
  }
}
